import React from 'react';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';

const useThemeClass = () => {
  const theme = useStore(state => state.ref.menu.activeTheme) || 'cardcolor';
  return `mafia-generic-card theme-${theme}`;
};

export const DiscussionPhaseScreen = ({ revealedWord }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-civilian">
          <div className="mpc-icon">🗣️</div>
          <div className="mpc-title">{t('mafia.discussion_title')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{t('mafia.discussion_desc')}</p>
          {revealedWord && <div className="mpc-target-word">{revealedWord}</div>}
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close_and_discuss')}
        </button>
      </div>
    </div>
  );
};

export const VotingPhaseScreen = () => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-mafia">
          <div className="mpc-icon">🗳️</div>
          <div className="mpc-title">{t('mafia.voting_title')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{t('mafia.voting_desc')}</p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {t('mafia.close_to_vote')}
        </button>
      </div>
    </div>
  );
};

export const NightSleepScreen = () => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className="mpc-header team-civilian">
          <div className="mpc-icon">🌃</div>
          <div className="mpc-title">{t('mafia.night_overlay_title')}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{t('mafia.night_overlay_desc')}</p>
        </div>
      </div>
    </div>
  );
};

export const WaitTurnScreen = ({ isMafiaWaiting }) => {
  const { t } = useTranslation();
  const cardClass = useThemeClass();

  const title = isMafiaWaiting ? t('mafia.drawing_complete') : t('mafia.time_up_civilian');
  const desc = isMafiaWaiting ? t('mafia.discussion_start') : t('mafia.now_mafia_turn');
  const btnText = isMafiaWaiting ? t('mafia.go_to_discussion') : t('mafia.close');
  const headerClass = isMafiaWaiting ? 'team-mafia' : 'team-civilian';
  const icon = isMafiaWaiting ? '🎭' : '⏰';

  return (
    <div className="mafia-overlay-bg">
      <div className={cardClass}>
        <div className={`mpc-header ${headerClass}`}>
          <div className="mpc-icon">{icon}</div>
          <div className="mpc-title">{title}</div>
        </div>
        <div className="mpc-content">
          <p className="mpc-desc">{desc}</p>
        </div>
        <button className="mpc-button" onClick={() => window.Telegram?.WebApp?.close()}>
          {btnText}
        </button>
      </div>
    </div>
  );
};